import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "visualiser-onboarding-content" }
const _hoisted_2 = {
  class: "frame-content",
  style: {"display":"none"}
}
const _hoisted_3 = { class: "visualiser-onboarding-description frame-description" }
const _hoisted_4 = {
  class: "fabric-content",
  style: {"display":"none"}
}
const _hoisted_5 = { class: "visualiser-onboarding-description fabric-description" }

import gsap from 'gsap';
import {computed, onMounted} from 'vue';
import {useStore} from '../store';

const start = 'M 0 100 V 100 Q 50 100 100 100 V 100 z';
const middleIn = 'M 0 100 V 50 Q 50 0 100 50 V 100 z';
const middleOut = 'M 0 100 V 50 Q 50 100 100 50 V 100 z';
const end = 'M 0 100 V 0 Q 50 0 100 0 V 100 z';


export default /*@__PURE__*/_defineComponent({
  __name: 'VisualiserScreenOnboarding',
  setup(__props) {

const store = useStore();

onMounted(onboarding1);

const tFrameDescription = computed(() => VisualiserConfig.locale === 'au'
    ? 'Customise the frame colour.'
    : 'Customize the frame color.')

const tFabricDescription = computed(() => VisualiserConfig.locale === 'au'
    ? 'Customise the fabric tone.'
    : 'Customize the fabric color.')

function onboarding1() {
    // shade fade in + move in
    const tl = gsap.timeline();
    tl.from('.shade', {attr: {d: start}});
    tl.to('.shade', {attr: {d: middleIn}, duration: 0.75, ease: 'power2.in'});
    tl.to('.shade', {attr: {d: end}, duration: 0.75, ease: 'power2.out'});
    // controls fade out
    gsap.fromTo('.visualiser-close', {opacity: 0}, {opacity: 1, delay: 1.25, duration: 1.00});
    gsap.to('.visualiser-controls-main, .visualiser-controls-divider, .visualiser-controls-toggle', {opacity: 0.15, delay: 1.25, duration: 1.00});
    gsap.to('.visualiser-controls-main.frame-control', {opacity: 1, delay: 2.25, duration: 1.00});
    // title fade in
    gsap.fromTo('.frame-title', {opacity: 0}, {opacity: 1, delay: 1.00, duration: 0.25});
    // details fade in
    gsap.fromTo('.frame-description', {opacity: 0}, {opacity: 1, delay: 1.25, duration: 1.00});
    // outlines in
    gsap.to('.fabric-line', {opacity: 0});
    gsap.fromTo('.frame-line', {opacity: 0}, {opacity: 1, delay: 1.25, duration: 1.00});
    for (const element of document.querySelectorAll('.frame-line')) {
        const length = (element as SVGPathElement).getTotalLength();
        gsap.fromTo(element, {strokeDashoffset: length, strokeDasharray: length}, {strokeDashoffset: 0, delay: 1.25, duration: 1.25});
    }
    // fill fade in
    gsap.to('.fabric-fill', {opacity: 0});
    gsap.fromTo('.frame-fill', {opacity: 0}, {opacity: 1, delay: 2.00, duration: 1.50});
    // circles in
    gsap.to('.frame-dot', {backgroundColor: 'rgba(255,255,255,1)'});
    gsap.to('.fabric-dot', {backgroundColor: 'rgba(255,255,255,0)'});
    gsap.fromTo('.visualiser-onboarding-progress', {opacity: 0}, {opacity: 1, delay: 2.00, duration: 1.00});
    // next button in
    gsap.fromTo('.frame-button', {opacity: 0}, {opacity: 1, delay: 2.50, duration: 1.00});

    (document.querySelector('.frame-content') as HTMLElement).style.display = 'block';
}

function onboarding2() {
    // title/details fade out
    gsap.fromTo('.frame-title', {opacity: 1}, {opacity: 0, duration: 0.75});
    gsap.fromTo('.frame-description', {opacity: 1}, {opacity: 0, duration: 0.75});
    // controls fade out
    gsap.to('.visualiser-controls-main, .visualiser-controls-divider, .visualiser-controls-toggle', {opacity: 0.15, duration: 0.75});
    // outlines out
    gsap.fromTo('.frame-line', {opacity: 1}, {opacity: 0, duration: 1.25});
    for (const element of document.querySelectorAll('.frame-line')) {
        const length = (element as SVGPathElement).getTotalLength();
        gsap.fromTo(element, {strokeDashoffset: 0}, {strokeDashoffset: length, delay: 0.25, duration: 1.00});
    }
    // fill fade out
    gsap.fromTo('.frame-fill', {opacity: 1}, {opacity: 0, delay: 0.25, duration: 0.75});
    // next button fade out
    gsap.fromTo('.frame-button', {opacity: 1}, {opacity: 0, duration: 0.75});

    // circles fade in
    gsap.to('.fabric-dot', {backgroundColor: 'rgba(255,255,255,1)', delay: 1.00});
    // title/details slide in
    gsap.fromTo('.fabric-title', {opacity: 0, transform: 'translateY(-28px)'}, {opacity: 1, transform: 'translateY(0)', delay: 1.00, duration: 1.00});
    gsap.fromTo('.fabric-description', {opacity: 0, transform: 'translateY(-28px)'}, {opacity: 1, transform: 'translateY(0)', delay: 1.00, duration: 1.00});
    // controls fade in
    gsap.to('.visualiser-controls-main.fabric-control', {opacity: 1, delay: 2.75, duration: 1.00});
    // outlines in
    gsap.fromTo('.fabric-line', {opacity: 0}, {opacity: 1, delay: 1.75, duration: 1.00});
    for (const element of document.querySelectorAll('.fabric-line')) {
        const length = (element as SVGPathElement).getTotalLength();
        gsap.fromTo(element, {strokeDashoffset: length, strokeDasharray: length}, {strokeDashoffset: 0, delay: 1.75, duration: 1.25});
    }
    // fill fade in
    gsap.fromTo('.fabric-fill', {opacity: 0}, {opacity: 1, delay: 2.50, duration: 1.50});
    // next button in
    gsap.to('.fabric-button', {opacity: 0});
    gsap.fromTo('.fabric-button', {opacity: 0}, {opacity: 1, delay: 3.00, duration: 1.00});

    (document.querySelector('.fabric-content') as HTMLElement).style.display = 'block';
    setTimeout(() => (document.querySelector('.frame-content') as HTMLElement).style.display = 'none', 1000);
}

function onboarding3() {
    // title/details/circles fade out
    gsap.fromTo('.visualiser-close', {opacity: 1}, {opacity: 0, duration: 0.75});
    gsap.fromTo('.fabric-title', {opacity: 1}, {opacity: 0, duration: 0.75});
    gsap.fromTo('.fabric-description', {opacity: 1}, {opacity: 0, duration: 0.75});
    gsap.to('.visualiser-onboarding-progress', {opacity: 0, duration: 0.75});
    gsap.to('.visualiser-controls-main, .visualiser-controls-divider, .visualiser-controls-toggle', {opacity: 0.15, duration: 0.75});
    // outlines out
    gsap.fromTo('.fabric-line', {opacity: 1}, {opacity: 0, duration: 1.25});
    for (const element of document.querySelectorAll('.fabric-line')) {
        const length = (element as SVGPathElement).getTotalLength();
        gsap.fromTo(element, {strokeDashoffset: 0, strokeDasharray: length}, {strokeDashoffset: length, delay: 0.25, duration: 1.00});
    }
    // fill fade out
    gsap.fromTo('.fabric-fill', {opacity: 1}, {opacity: 0, delay: 0.25, duration: 0.75});
    // next button fade out
    gsap.fromTo('.fabric-button', {opacity: 1}, {opacity: 0, duration: 0.75});
    // controls fade in
    gsap.to('.visualiser-controls-main, .visualiser-controls-divider, .visualiser-controls-toggle', {opacity: 1, delay: 1.25, duration: 1.00});
    // shade transition out
    const tl = gsap.timeline();
    tl.from('.shade', {attr: {d: end}});
    tl.to('.shade', {attr: {d: middleOut}, duration: 0.75, ease: 'power2.in'});
    tl.to('.shade', {attr: {d: start}, duration: 0.75, ease: 'power2.out'});

    setTimeout(() => store.showOnboarding = false, 2500);
}

function closeOnboarding() {
    // title/details fade out
    gsap.to('.visualiser-close', {opacity: 0, duration: 0.75});
    gsap.to('.frame-title, .fabric-title', {opacity: 0, duration: 0.75});
    gsap.to('.frame-description, .fabric-description', {opacity: 0, duration: 0.75});
    // controls fade out
    gsap.to('.visualiser-onboarding-progress', {opacity: 0, duration: 0.75});
    gsap.to('.visualiser-controls-main, .visualiser-controls-divider, .visualiser-controls-toggle', {opacity: 0.15, duration: 0.75});
    // outlines out
    gsap.to('.frame-line, .fabric-line', {opacity: 0, duration: 1.25});
    for (const element of document.querySelectorAll('.frame-line, .fabric-line')) {
        const length = (element as SVGPathElement).getTotalLength();
        gsap.to(element, {strokeDashoffset: length, delay: 0.25, duration: 1.00});
    }
    // fill fade out
    gsap.to('.frame-fill, .fabric-fill', {opacity: 0, delay: 0.25, duration: 0.75});
    // next button fade out
    gsap.to('.frame-button, .fabric-button', {opacity: 0, duration: 0.75});

    // controls fade in
    gsap.to('.visualiser-controls-main, .visualiser-controls-divider, .visualiser-controls-toggle', {opacity: 1, delay: 1.25, duration: 1.00});
    // shade transition out
    const tl = gsap.timeline();
    tl.from('.shade', {attr: {d: end}});
    tl.to('.shade', {attr: {d: middleOut}, duration: 0.75, ease: 'power2.in'});
    tl.to('.shade', {attr: {d: start}, duration: 0.75, ease: 'power2.out'});

    setTimeout(() => store.showOnboarding = false, 2500);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"visualiser-onboarding\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2000 1144\"><polygon class=\"frame-fill\" points=\"324.985 496.861 324.985 516.287 340.022 518.233 339.167 866.004 600.29 904.645 600.29 889.897 344.19 857.235 345.553 518.233 600.84 413.941 600.84 373.154 324.985 496.861\"></polygon><polygon class=\"frame-fill\" points=\"1331.092 467.188 1331.096 494.334 1722.817 543.224 1724.937 848.072 1333.144 864.241 1333.144 874.997 1729.416 856.489 1727.678 543.233 1740.315 542.138 1740.315 524.255 1331.092 467.188\"></polygon><path class=\"frame-fill\" d=\"m1314.316,465.587l-665.957-95.679-4.609,1.281.315,536.121,659.929-30.098-2.47-387.855,12.793-1.901v-21.869Zm-666.659,429.062l.707-490.104,647.762,83.488,2.665,379.342-651.134,27.273Z\"></path><polyline class=\"frame-line\" points=\"648.364 404.546 1296.126 488.034 1298.791 867.376 647.657 894.65 648.359 369.908\"></polyline><polyline class=\"frame-line\" points=\"648.382 369.919 643.75 371.189 644.064 907.31 1303.993 877.212 1301.523 489.358 1314.316 487.457\"></polyline><polyline class=\"frame-line\" points=\"648.359 369.908 1314.316 465.587 1314.32 487.078\"></polyline><line class=\"frame-line\" x1=\"1314.316\" y1=\"487.457\" x2=\"648.847\" y2=\"398.89\"></line><polyline class=\"frame-line\" points=\"1331.096 494.334 1722.817 543.224 1724.937 848.072 1333.144 864.241\"></polyline><line class=\"frame-line\" x1=\"1740.315\" y1=\"542.138\" x2=\"1331.088\" y2=\"489.358\"></line><polyline class=\"frame-line\" points=\"1331.092 467.188 1740.315 524.255 1740.315 542.138 1727.678 543.233 1729.416 856.489\"></polyline><polyline class=\"frame-line\" points=\"1331.092 467.188 1333.144 874.997 1729.416 856.489\"></polyline><polyline class=\"frame-line\" points=\"556.554 393.015 324.985 496.861 324.985 516.287 340.022 518.233 339.167 866.004\"></polyline><polyline class=\"frame-line\" points=\"556.554 393.015 600.84 373.154 600.29 904.645 339.167 866.004\"></polyline><line class=\"frame-line\" x1=\"324.985\" y1=\"516.287\" x2=\"600.856\" y2=\"401.344\"></line><polyline class=\"frame-line\" points=\"600.84 413.941 345.553 518.233 344.19 857.235 600.29 889.897\"></polyline><polygon class=\"fabric-fill\" points=\"345.553 518.233 600.84 413.941 600.29 889.897 344.19 857.235 345.553 518.233\"></polygon><polygon class=\"fabric-fill\" points=\"648.382 405.692 1296.126 488.034 1298.791 867.376 647.657 894.65 648.382 405.692\"></polygon><polygon class=\"fabric-fill\" points=\"1331.094 493.983 1722.817 543.224 1724.937 848.072 1333.144 864.241 1331.094 493.983\"></polygon><polyline class=\"fabric-line\" points=\"533.673 441.381 600.84 413.941 600.29 889.897\"></polyline><line class=\"fabric-line\" x1=\"600.29\" y1=\"889.897\" x2=\"344.19\" y2=\"857.235\"></line><polyline class=\"fabric-line\" points=\"344.19 857.235 345.553 518.233 533.673 441.381\"></polyline><polyline class=\"fabric-line\" points=\"824.811 428.12 1296.126 488.034 1298.791 867.376 1182.305 872.255\"></polyline><polyline class=\"fabric-line\" points=\"1182.305 872.255 647.657 894.65 648.382 405.692 824.811 428.12\"></polyline><polyline class=\"fabric-line\" points=\"1703.666 848.95 1724.937 848.072 1722.817 543.224 1331.094 493.983\"></polyline><polyline class=\"fabric-line\" points=\"1331.094 493.983 1333.144 864.241 1703.666 848.95\"></polyline></svg></div>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "visualiser-onboarding-progress" }, [
        _createElementVNode("div", { class: "visualiser-onboarding-progress-dot frame-dot" }),
        _createElementVNode("div", { class: "visualiser-onboarding-progress-dot fabric-dot" })
      ], -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "visualiser-onboarding-title frame-title" }, "Zipscreen Frame", -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_3, _toDisplayString(tFrameDescription.value), 1 /* TEXT */),
        _createElementVNode("button", {
          type: "button",
          class: "btn visualiser-btn frame-button",
          onClick: onboarding2
        }, _cache[0] || (_cache[0] = [
          _createTextVNode(" Next "),
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 12 11"
          }, [
            _createElementVNode("polygon", { points: "0 0 0 11 12 5.5 0 0" })
          ], -1 /* HOISTED */)
        ]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "visualiser-onboarding-title fabric-title" }, "Zipscreen Fabric", -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_5, _toDisplayString(tFabricDescription.value), 1 /* TEXT */),
        _createElementVNode("button", {
          type: "button",
          class: "btn visualiser-btn fabric-button",
          onClick: onboarding3
        }, _cache[2] || (_cache[2] = [
          _createTextVNode(" Get started "),
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 12 11"
          }, [
            _createElementVNode("polygon", { points: "0 0 0 11 12 5.5 0 0" })
          ], -1 /* HOISTED */)
        ]))
      ])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "none",
      class: "visualiser-onboarding-shade"
    }, [
      _createElementVNode("path", {
        class: "shade",
        d: "M 0 100 V 100 Q 50 100 100 100 V 100 z"
      })
    ], -1 /* HOISTED */)),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "visualiser-onboarding-block" }, null, -1 /* HOISTED */)),
    _createElementVNode("button", {
      type: "button",
      class: "btn visualiser-close",
      onClick: closeOnboarding
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor"
      }, [
        _createElementVNode("path", { d: "M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" })
      ], -1 /* HOISTED */)
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}
}

})